import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export const OrgChartSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col h-screen bg-background">
      {/* Header */}
      <div className="border-b bg-background px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="space-y-2">
              <Skeleton className="h-8 w-64" />
              <Skeleton className="h-4 w-48" />
            </div>
            <Skeleton className="h-10 w-40" />
          </div>
          <div className="flex items-center gap-2">
            <Skeleton className="h-10 w-32" />
            <Skeleton className="h-10 w-24" />
            <Skeleton className="h-10 w-24" />
          </div>
        </div>
      </div>

      {/* Chart Area */}
      <div className="flex-1 overflow-hidden bg-muted/30 p-8">
        <div className="flex flex-col items-center gap-8">
          {/* Top position */}
          <Skeleton className="h-32 w-64 rounded-lg" />
          
          {/* Second level */}
          <div className="flex gap-6">
            <Skeleton className="h-32 w-48 rounded-lg" />
            <Skeleton className="h-32 w-48 rounded-lg" />
            <Skeleton className="h-32 w-48 rounded-lg" />
          </div>
          
          {/* Third level */}
          <div className="flex gap-8">
            <Skeleton className="h-28 w-40 rounded-lg" />
            <Skeleton className="h-28 w-40 rounded-lg" />
            <Skeleton className="h-28 w-40 rounded-lg" />
            <Skeleton className="h-28 w-40 rounded-lg" />
          </div>
        </div>
      </div>
    </div>
  );
};
